import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_common_subtract",
  "use": "lc_common_subtract-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_common_subtract\"><defs><style type=\"text/css\"></style></defs><path d=\"M56.888889 455.111111m56.888889 0l796.444444 0q56.888889 0 56.888889 56.888889l0 0q0 56.888889-56.888889 56.888889l-796.444444 0q-56.888889 0-56.888889-56.888889l0 0q0-56.888889 56.888889-56.888889Z\" p-id=\"2004\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol